import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import styles from './ProductCardBookmark.module.scss';
import useBookmarkToggle from '@/hooks/useBookmark';
type ProductCardBookmarkProps = {
  id: number;
};
const ProductCardBookmark: FC<ProductCardBookmarkProps> = ({
  id
}) => {
  const {
    isBookmarked,
    toggleBookmark
  } = useBookmarkToggle(id);
  return <Box className={styles['bookmark_section']} onClick={() => toggleBookmark()} id={'home-card-fave'} data-sentry-element="Box" data-sentry-component="ProductCardBookmark" data-sentry-source-file="ProductCardBookmark.tsx">
      <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} data-sentry-element="Icon" data-sentry-source-file="ProductCardBookmark.tsx" />
    </Box>;
};
export default ProductCardBookmark;